export default __webpack_public_path__ + "static/adaptix-2cffc93ed5c3715cc19edcdd7d414643.jpg";